<template>
	<section id="faq" class="faq">
		<div class="container inner">
			<div class="section-head">
				<span class="label">FAQ</span>
				<h2 class="cap section-title">New to<br />the mats?</h2>
			</div>
			<div class="list">
				<div v-for="(item, i) in faqs" :key="item.q" class="item">
					<button
						:id="'faq-q-' + i"
						type="button"
						class="question"
						:aria-expanded="open === i"
						:aria-controls="'faq-a-' + i"
						@click="open = open === i ? -1 : i"
					>
						<span>{{ item.q }}</span>
						<span class="mono sign" aria-hidden="true">{{ open === i ? "−" : "+" }}</span>
					</button>
					<p v-show="open === i" :id="'faq-a-' + i" class="answer" role="region" :aria-labelledby="'faq-q-' + i">
						{{ item.a }}
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { faqs } from "../../data/site.js";

export default {
	data() {
		return { faqs, open: 0 };
	},
};
</script>

<style scoped>
.faq {
	background: var(--white);
	border-top: 1px solid var(--line);
}

.inner {
	padding-top: 80px;
	padding-bottom: 80px;
	display: flex;
	flex-wrap: wrap;
	gap: 40px;
}

.section-head {
	flex: 1 1 280px;
}

.list {
	flex: 2 1 520px;
	display: flex;
	flex-direction: column;
	border-top: 1px solid var(--line);
}

.item {
	border-bottom: 1px solid var(--line);
}

.question {
	width: 100%;
	min-height: 60px;
	padding: 12px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 16px;
	border: 0;
	background: transparent;
	color: var(--ink);
	font: 600 17px var(--body);
	text-align: left;
	cursor: pointer;
}

.sign {
	font-size: 18px;
}

.answer {
	margin-bottom: 18px;
	color: #3a3a3a;
}

@media (max-width: 768px) {
	.faq {
		margin-top: 48px;
	}

	.inner {
		padding-top: 48px;
		padding-bottom: 48px;
		gap: 16px;
	}

	.list {
		flex-basis: 100%;
	}

	.question {
		font-size: 16px;
	}

	.answer {
		margin-bottom: 16px;
		font-size: 15px;
	}
}
</style>
